import { render, staticRenderFns } from "./Navi.vue?vue&type=template&id=68d50e1c&scoped=true&"
import script from "./Navi.vue?vue&type=script&lang=js&"
export * from "./Navi.vue?vue&type=script&lang=js&"
import style0 from "./Navi.vue?vue&type=style&index=0&id=68d50e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d50e1c",
  null
  
)

export default component.exports